import { makeDSClient } from "@/lib/clients";
import { queryClient } from "@/lib/query-client";
import { DSContractState } from "@myth-finance/dualstake-ts-sdk";
import { useQuery } from "@tanstack/react-query";
import { clearListingsCache } from "./use-listings";
import { clearAPRCache } from "./use-apr-breakdown";
import { clearFarmsAndAPRCache } from "./use-farms-and-aprs";
import { clearAlgoAcctInfoCache } from "./use-algo-account";

export const useCState = (appId: bigint, account?: string) => {
  return useQuery({
    queryKey: ["cState", String(appId), account ?? "anon"],
    staleTime: 60 * 1_000,
    enabled: !!appId,
    queryFn: async (): Promise<DSContractState> => {
      if (!appId) return {} as DSContractState;
      console.debug("Requesting cState", appId, account);
      return makeDSClient(appId, account)
        .getState()
        .catch((e: Error) => {
          const msg = e?.message ?? e;
          if (
            msg.includes("overspend (account " + account) ||
            msg.includes("account " + account + " balance ")
          ) {
            return makeDSClient(appId).getState();
          } else throw e;
        })
        .catch((e: Error) => {
          throw new Error(`While reading dualSTAKE state: ${e?.message ?? e}`);
        });
    },
  });
};

export const clearCStateCache = (appId?: bigint) => {
  const queryKey = ["cState"];
  if (appId) queryKey.push(String(appId));
  queryClient.invalidateQueries({ queryKey });
};

export const clearDSCache = (appId?: bigint) => {
  clearCStateCache(appId);
  clearListingsCache();
  clearAPRCache(appId);
  clearFarmsAndAPRCache();
  clearAlgoAcctInfoCache();
};
